import { ShieldCheck } from "lucide-react";
import { PlaceholderSection } from "@/components/settings/PlaceholderSection";

export function SecuritySection() {
  return <PlaceholderSection id="security" title="Sign-in and security" description="Your password and how you sign in." icon={<ShieldCheck />} />;
}
